import { render, staticRenderFns } from "./salesPreferential.vue?vue&type=template&id=0e154215&scoped=true"
import script from "./salesPreferential.vue?vue&type=script&lang=js"
export * from "./salesPreferential.vue?vue&type=script&lang=js"
import style0 from "./salesPreferential.vue?vue&type=style&index=0&id=0e154215&prod&scoped=true&lang=css"
import style1 from "./salesPreferential.vue?vue&type=style&index=1&id=0e154215&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e154215",
  null
  
)

export default component.exports